import { BaseService } from '../base-service'

export class StatisticsService extends BaseService {
    /**
     * Получить время между запросами на обновление статистических данных
     * @returns {Promise<number>} время в миллисекундах
     */
    getDataRefreshTime = async () => {
        return super.get('/api/statistics/refresh-time')
    }

    /**
     * Получить количество активных и проданных акцизных марок
     * @param {string|Array<string>} type - позволяет задать тип акцизной марки
     * @returns {Promise<ExciseCountObject>}
     */
    getExciseCount = async (type) => {
        return super.get('/api/statistics/excise-count', { type })
    }

    /**
     * Получить историю последних запросов по акцизным маркам
     * @param {number} count - Запрашиваемое количество записей
     * @param {string|Array<string>} type - Тип акцизной марки
     * @returns {Promise<Array<RequestEntry>>}
     */
    getRequestHistory = async (count = 15, type) => {
        return super.get('/api/statistics/request-history', { count, type })
    }

    /**
     * Получить историю нарушений по акцизным маркам
     * @param {object} filters - Применяемые фильтры
     * @param {number} filters.dateFrom - Дата в long формате
     * @param {number} filters.dateTo - Дата в long формате
     * @param {number} filters.cash - Номер кассы
     * @param {number} filters.errorCode - Код ошибки
     * @param {string} filters.barcode - Штрих-код продукта или промо-набора
     * @param {number} limit - Максимальное количество возвращаемых записей
     * @returns {Promise<ErrorLogResponse>}
     */
    getErrorLog = async ({ dateFrom, dateTo, cash, errorCode, barcode }, limit) => {
        return super.get('/api/statistics/error-log', { dateFrom, dateTo, cash, errorCode, barcode, limit })
    }

    /**
     * Получить список кодов ошибок и их описание
     * @returns {Promise<Array<ErrorType>>}
     */
    getErrorCodes = async () => {
        return super.get('/api/statistics/error-codes')
    }
}

export const statisticsService = new StatisticsService()

/**
 * @typedef {Object} ExciseCountObject
 * @property {number} active Количество активных марок
 * @property {number} sold Количество проданных марок
 */

/**
 * @typedef {Object} RequestEntry
 * @property {number} id
 * @property {number} cash Номер кассы
 * @property {string} excise Код акцизной марки
 * @property {string} info Описание операции
 * @property {string} date Дата операции
 */

/**
 * @typedef {Object} ErrorLogResponse
 * @property {number} total Общее число записей в журнале, удовлетворяющих заданным условиям
 * @property {Array<ErrorEntry>} items Записи нарушений (количество ограничено параметром limit в запросе)
 */
/**
 * @typedef {Object} ErrorEntry
 * @property {number} id
 * @property {number} errorCode Код нарушения
 * @property {string} errorMessage Описание нарушения
 * @property {number} cash Номер кассы
 * @property {string} date Дата
 * @property {number} promoBarcode Штрих-код промонабора
 * @property {number} barcode Штрих-код продукта
 * @property {string} excise Код акцизной марки
 */

 /**
  * @typedef {Object} ErrorType
  * @property {number} errorCode
  * @property {string} errorMessage
  */
